// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://iiqleqeqhnesxzxpdpmc.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlpcWxlcWVxaG5lc3h6eHBkcG1jIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk2MDY3NzEsImV4cCI6MjA4NTE4Mjc3MX0.XWsiFefdGBMRiaqVw9CWLV3PrXb8LlFOr7kJ1wHf1hQ";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
